export const getVisualViewportBounds = (visualViewport, fallback = {}) => {
  const fallbackWidth = Number.isFinite(fallback.width) ? fallback.width : 0;
  const fallbackHeight = Number.isFinite(fallback.height) ? fallback.height : 0;

  return {
    left: Number.isFinite(visualViewport?.offsetLeft) ? visualViewport.offsetLeft : 0,
    top: Number.isFinite(visualViewport?.offsetTop) ? visualViewport.offsetTop : 0,
    width: Number.isFinite(visualViewport?.width) && visualViewport.width > 0
      ? visualViewport.width
      : fallbackWidth,
    height: Number.isFinite(visualViewport?.height) && visualViewport.height > 0
      ? visualViewport.height
      : fallbackHeight,
  };
};

export const visualViewportBoundsEqual = (first, second) => (
  first.left === second.left
  && first.top === second.top
  && first.width === second.width
  && first.height === second.height
);
